import React, { useState } from 'react';

function RenewModal({ isOpen, onClose, onConfirm, customerName }) {
  const [expiryDate, setExpiryDate] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!expiryDate) {
      setError('Please select an expiry date.');
      return;
    }

    const selectedDate = new Date(expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
      setError('Expiry date must be in the future.');
      return;
    }

    onConfirm(expiryDate);
  };

  const handleClose = () => {
    setExpiryDate('');
    setError('');
    onClose();
  };

  // Set minimum date to tomorrow
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minDate = tomorrow.toISOString().split('T')[0];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Renew Customer</h2>
          <button className="modal-close" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <p>
            Renew <strong>{customerName}</strong> by setting a new expiry date. All customer
            admins and users will have their expiry dates updated to match.
          </p>

          {error && <div className="alert error">{error}</div>}

          <form onSubmit={handleSubmit} className="stacked-form">
            <label>
              New Expiry Date
              <input
                type="date"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e.target.value)}
                min={minDate}
                required
              />
            </label>

            <div className="modal-actions">
              <button type="button" className="secondary-button" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="primary-button">
                Renew Customer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RenewModal;

